<template>
  <div>
    <div class="admin-upload">
      <div class="avatar">
        <img src="../../../assets/images/avt-exp.svg" alt class="avt-modal" ref="displayImage"/>
        <div class="input-upload">
          <label for="uploadfile" class="label-upload"></label>
          <input type="file" id="uploadfile" name="uploadfile" class="btn-file input-0"  @change="changeImage($event)"/>
        </div>
      </div>
    </div>
    <div class="vendor__title"></div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SidebarVendor',
  methods: {
    changeImage (event) {
      this.editLogoCompany.logo = event.target.files[0]
      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.$refs.displayImage.src = reader.result
      }.bind(this), false)
      reader.readAsDataURL(this.editLogoCompany.logo)
    }
  },
  computed: {
    ...mapState({
      editLogoCompany: state => state.adminCompany.editLogoCompany
    })
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/stylesheet/admin/vendor.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/SidebarAdd.vue